import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import ROUTES from '@src/constants/route';
import NotificationDialogV4 from '@src/components/NotificationDialogV4';
import iconUpgrade from '@src/assets/images/icon-paid-package.png';
import {
  PACK_DURATION,
  PACKAGE_CODE_V3,
  PACKAGE_LEVEL_V3,
  PACKAGE_TYPE,
  TOP_UP_PACKAGE_CODES,
} from '@src/constants/package';
import { useMappingPackage } from '@src/hooks/useMappingPackage';

const OutOfCreditsSpecial = ({ open, onClose, packageCode, voice = {} }) => {
  const { handleGetPackageCodeMapping } = useMappingPackage();
  const eolVoice = voice?.eolDate;
  const { t } = useTranslation();
  const history = useHistory();

  const handleBuyMore = () => {
    const url = `${ROUTES.PAYMENT}?package=${TOP_UP_PACKAGE_CODES[1]}`;
    history.push(url);
  };

  const handleUpgradeVIP = () => {
    const mappingUpgradePackage = {
      [PACKAGE_CODE_V3.STUDIO_SPECIAL_MONTH_V3]: {
        level: PACKAGE_LEVEL_V3.VIP,
        type: PACKAGE_TYPE.STUDIO,
        expiresIn: PACK_DURATION.MONTH,
      },
      [PACKAGE_CODE_V3.STUDIO_SPECIAL_YEAR_V3]: {
        level: PACKAGE_LEVEL_V3.VIP,
        type: PACKAGE_TYPE.STUDIO,
        expiresIn: PACK_DURATION.YEAR,
      },
    };
    const upgradePackage = handleGetPackageCodeMapping(
      mappingUpgradePackage[packageCode],
    );
    if (upgradePackage) {
      const url = `${ROUTES.PAYMENT}?package=${upgradePackage}`;
      history.push(url);
    }
  };

  const renderBuyMoreButton = () => {
    if (eolVoice) {
      return (
        <>
          <Button variant="contained" onClick={onClose}>
            {t('gotIt')}
          </Button>
          <Button className="outlined-button" onClick={handleUpgradeVIP}>
            {t('upgradePackage')}
          </Button>
        </>
      );
    }

    return (
      <Button variant="contained" onClick={handleBuyMore}>
        {t('buyMoreChar')}
      </Button>
    );
  };

  const renderDescription = () => {
    if (eolVoice) {
      return t('descriptionOutOfCreditsStandardEOL');
    }
    return t('descriptionOutOfCreditsSpecial');
  };

  return (
    <NotificationDialogV4
      image={iconUpgrade}
      title={t('outOfCredits')}
      description={renderDescription()}
      actionComponent={renderBuyMoreButton()}
      open={open}
      onClose={onClose}
    />
  );
};

export default OutOfCreditsSpecial;
